import { userList } from './tableColumns'
import {
	User,
	CashRegisters,
	Permissions,
	WaiterKey,
	Bill,
	FilterComponent
} from './'
import { listUsers, getUser, createUser, updateUser, updateManyUsers } from './gql'
import { Profile, History } from 'media/icons'
import HistoryModal from 'components/HistoryModal'
import GridView from './GridView'
import { isRouteDisabled } from 'sections/utils'

export default (t, rights) => ({
	id: '5',
	label: t('user_section.caption'),
	typename: 'User',
	link: isRouteDisabled(rights, '5') ? null : 'benutzer',
	linkDisabled: isRouteDisabled(rights, '5'),
	recordsCounter: true,
	icon: Profile,
	requiredFields: ['name', 'code'],
	uniqueFields: ['code', 'password'],
	multiEditConfig: [
		{
			fieldName: 'isActive',
			type: 'checkbox',
			label: t('common.fields.isActive')
		},
		{
			fieldName: 'timeTrackingId',
			type: 'text',
			label: 'E2N Security-Token'
		},
		{
			fieldName: 'shortName',
			type: 'text',
			label: t('user_section.fields.short_name')
		},
		{
			fieldName: 'printName',
			type: 'text',
			label: t('user_section.fields.bill_name')
		},
		{
			fieldName: 'dateInterval',
			type: 'date',
			label: t('user_section.fields.active_period')
		},
		{
			fieldName: 'isPasswordOnlyForLogin',
			type: 'checkbox',
			label: t('user_section.fields.isPasswordOnlyForLogin')
		},
		{
			fieldName: 'performance',
			type: 'number',
			label: t('user_section.fields.performance')
		}
	],
	subsections: [{
		name: t('user_section.sub_sections.user'),
		link: '',
		component: User,
		updateMutation: updateUser.user,
		fields: ['code', 'isActive', 'name', 'shortName', 'printName', 'password', 'performance', 'timeTrackingId', 'isPasswordOnlyForLogin', 'shopId', {
			fieldName: 'dateInterval',
			__typename: 'DateTimeInterval',
			children: ['to', 'from']
		}]
	}, {
		name: t('common.strings.cash_register_subsection'),
		link: 'kasse',
		component: CashRegisters,
		updateMutation: updateUser.cashRegisters,
		fields: ['cashRegisterId']
	}, {
		name: t('user_section.sub_sections.rights'),
		link: 'rechte',
		component: Permissions,
		updateMutation: updateUser.permissions,
		fields: ['isAdmin', 'isManager', 'isFinStatements', 'isDayFinStatements', 'isViewSales', 'isTimeTracking', 'isOnlyNonManagerTables', 'cancelationPermissions', 'typeRFID', 'codeExtern']
	}, {
		name: t('user_section.sub_sections.waiter_key'),
		link: 'kellner-schloss',
		component: WaiterKey,
		updateMutation: updateUser.waiterKey,
		fields: ['waiterKey']
	}, {
		name: t('user_section.sub_sections.pecuniary_advantage'),
		link: 'belege',
		component: Bill,
		updateMutation: updateUser.monthlyTaxFreeAmount,
		fields: ['monthlyTaxFreeAmount']
	}, {
		link: 'grid',
		component: GridView,
		hideInNav: true,
		overrideHandler: true
	}],
	sideListProps: {
		datatableProps: {
			defaultSorted: [{
				id: 'isActive',
				desc: true
			}]
		}
	},
	columns: userList(t),
	listQuery: listUsers,
	itemQuery: getUser,
	createMutation: createUser,
	addNewRecord: true,
	FilterComponent,
	newRecordsDefaults: {
		isActive: true,
		isPasswordOnlyForLogin: true
	},
	contextTypes: {
		searchCR: 'string'
	},
	itemActions: [{
		label: t('product_section.strings.update_group'),
		action: ({ multiEdit, data }) => multiEdit.setIsActive(!multiEdit.isActive, data.id)
	}, {
		label: t('common.strings.history'),
		Icon: History,
		modalComponent: HistoryModal
	}, {
		label: t('common.strings.grid_view'),
		action: ({ history, recordId }) => history.push({
			pathname: `/benutzer/grid${recordId ? '/' + recordId : ''}`
		})
	}],
	multiEditMutation: updateManyUsers
})

